import { FormInstance } from 'antd';
import { LocalizedEditPackInput } from 'apollo/localizedTypes';
import mapLocalizedText from 'utils/i18n/mapLocalizedText';
import mapOptionalLocalizedRichText from 'utils/i18n/mapOptionalLocalizedRichText';
import { PackCreate, PackEdit } from '../types';

const packConfigurationFormToInput = (
  form: FormInstance,
  id?: string
): PackEdit | PackCreate => {
  const formValues = form.getFieldsValue(true) as LocalizedEditPackInput;
  const mappedFormValues = {
    activities: formValues.activities || [],
    adultValue: Number(formValues.adultValue),
    description: mapOptionalLocalizedRichText(formValues.description),
    entranceTicketTypes: formValues.entranceTicketTypes || [],
    features: formValues.features || [],
    name: mapLocalizedText(formValues.name),
    otherValue: Number(formValues.otherValue),
    promotionCodePacks: undefined,
    status: formValues.status !== undefined ? Boolean(formValues.status) : undefined,
  };
  if (id) {
    return { id, ...mappedFormValues };
  }
  return mappedFormValues;
};

export default packConfigurationFormToInput;
